var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-layout',{staticClass:"bg-mural mural-font",attrs:{"view":"hHh Lpr lff"}},[_c('q-header',{staticClass:"bg-primary",attrs:{"elevated":""}},[_c('ToolbarLayout')],1),(_vm.isAdmin)?_c('MenuLayout'):_vm._e(),_c('q-page-container',[_c('router-view')],1),_c('FilterLayout'),_c('CropLayout'),_c('ChartLayout')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }